import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import Typo from 'constants/typography'
import Icon from 'components/common/icon'
import ICONS, { ICON_SIZE } from 'components/common/icon/const'
import useWindowSize from 'components/custom-hooks/useWindowSize'
import ResponsiveImage from 'components/images/responsive-image'
import styles from './style.scss'
import TTBH_HEADER from './const'
import { ASSETS } from '../const'

const TTBHomeHeader = ({ isPhone, t, toNextSection }) => {
  const windowWidth = useWindowSize().width

  return (
    <Fragment>
      <style jsx>{styles}</style>
      <div className="ttb-header__wrapper">
        <div className="ttb-header__banner-info">
          <span className={Typo.h5}>
            {hasLocizeTranslation(
              t,
              TTBH_HEADER.subtitle.disabledKey,
              TTBH_HEADER.subtitle.value,
            )}
          </span>
          <span className={clsx('ttb-header__banner-info__title', Typo.h3)}>
            {hasLocizeTranslation(
              t,
              TTBH_HEADER.title.disabledKey,
              TTBH_HEADER.title.value,
            )}
          </span>
          <Icon
            className={clsx('ttb-header__arrow-icon')}
            onClick={toNextSection}
            src={ICONS.arrowDown}
            size={ICON_SIZE.medium}
            alt="down_arrow"
          />
        </div>
        {(!isPhone || windowWidth >= 768) && (
          <div className="ttb-header__banner-img">
            <ResponsiveImage imgRatio={1.25} src={ASSETS.HERO_BANNER} />
          </div>
        )}
      </div>
    </Fragment>
  )
}

TTBHomeHeader.propTypes = {
  isPhone: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  toNextSection: PropTypes.func.isRequired,
}

const Extended = withI18next()(TTBHomeHeader)

export default connect((state) => ({
  isPhone: state.device.isPhone,
}))(Extended)
